/**
 * Enum for user roles.
 * @readonly
 * @enum {string}
 */
const userRoles = Object.freeze({
  admin: 'ADMIN',
  user: 'USER',
  vender: 'VENDER',
});

export { userRoles };
